<template>

	<div class="portlet box green" v-if="classLevel === 'Bercario' || classLevel === 'Infantil'">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-male" aria-hidden="true"></i>
				<i class="fa fa-female" aria-hidden="true"></i>
				<span v-translate>Urina</span>
			</div>

		</div>

		<div class="portlet-body">

			<div class="form-group">

				<label class="control-label">O aluno urinou hoje?</label>

				<div class="mt-radio-inline">

					<label class="mt-radio mt-radio-outline">
						<input type="radio" name="urine" value="1" :checked="piss =='1'" @change="putAgendaUrine">
						Sim
						<span></span>
					</label>

					<label class="mt-radio mt-radio-outline">
						<input type="radio" name="urine" value="0" :checked="piss =='0'" @change="putAgendaUrine">
						Não
						<span></span>
					</label>

				</div>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentUrineQuantity from './';
	export default StudentUrineQuantity;

</script>

<style lang="scss" scoped>

	.control-label {
		margin-bottom: 20px;
	}

	.form-group,
	.mt-radio {
		margin-bottom: 0;
	}

</style>



// WEBPACK FOOTER //
// urine-quantity.vue?270c754c